<template>
    <el-row>
        <el-row class="column-name" justify="start">
            <span>设备</span>
            <div class="navbar-right">
                <el-button type="info" plain size="minimum" @click="toAdd" v-if="addBtnExisted" :disabled="!addable">新增</el-button>
                <equipment-page-select-dialog ref="dialog" @confirm="handleConfirm">
                </equipment-page-select-dialog>
            </div>
        </el-row>
        <el-row>
            <equipment-group-equipment-page ref="equipmentGroupEquipmentPage" :group-id="groupId">
            </equipment-group-equipment-page>
        </el-row>
    </el-row>
</template>

<script>
    import DcimSever from "@/api/dcim";
    import EquipmentPageSelectDialog from "@/views/dcim/equipment/equipment-page-select-dialog";
    import EquipmentGroupEquipmentPage from "@/views/dcim/equipment-group/equipment-group-equipment-page";

    export default {
        name: "equipment-group-equipment-panel",
        props: {
            groupId: {},
            addable: {
                type: Boolean,
                default: false,
            },
        },
        components: {
            EquipmentPageSelectDialog, EquipmentGroupEquipmentPage,
        },
        data() {
            return {

            };
        },
        computed: {
            addBtnExisted() {
                return true;
            },
        },
        methods: {
            toAdd() {
                this.$refs.dialog.open();
            },
            async handleConfirm(selectedRows) {
                let groupId = this.groupId;
                let itemIds = selectedRows.map(e => e.id);
                if (groupId != null && groupId !== '' &&
                    itemIds != null && itemIds.length > 0) {
                    await DcimSever.equipmentGroup.batchJoin(groupId, itemIds);
                    this.$message.success('添加设备成功！');
                    this.$refs.equipmentGroupEquipmentPage.reQueryByPage();
                    this.$refs.dialog.close();
                }
            },
        },
    }
</script>

<style scoped>

</style>
